const API_URL = process.env.REACT_APP_API_URL;
const API = (endpoint, method, data) => {
  return new Promise((resolve, reject) => {
    let options = {
      method: method,
      headers: {
        "Content-Type": "application/json",
      },
    };
    if (data) options.body = JSON.stringify(data);
    fetch(API_URL + endpoint, options)
      .then((response) => response.json())
      .then((responseJson) => resolve(responseJson))
      .catch((error) => reject(error));
  });
};

export default API;
